import React from 'react';
import { useDocumentStore } from '../hooks/useDocumentStore';
import WizardTextInputControlledComponent from 'components/v2/epd-wizard-inputs/WizardTextInputControlled';
import VersionHistoryDialog from '../components/dialogs/VersionHistoryDialog';
import VersionComparerDialog from '../components/dialogs/VersionComparerDialog';
import { useDynamicFormsDocumentVersions } from 'services/api/queries';
import { useHasRole } from 'hooks/useRoleCheck';
import { RoleName } from 'constants/constants';
import DocumentCommentLogButton from '../../comment-log/DocumentCommentLogButton';

const EpdMetadataRenderer: React.FC = () => {
  const { metadata, docId } = useDocumentStore();
  const documentVersions = useDynamicFormsDocumentVersions(docId);
  const isAdmin = useHasRole(RoleName.ADMIN);
  const isLicenseeAdmin = useHasRole(RoleName.LICENSEE_ADMIN);

  return (
    <>
      <WizardTextInputControlledComponent
        label="UUID of data set"
        tooltip="Automatically generated universally unique identifier of this data."
        name="uuid"
        value={docId}
        disabled
      />
      <WizardTextInputControlledComponent
        label="EPD Id"
        name="registrationNumber"
        tooltip="Automatically generated unique identifier for this EPD."
        value={metadata.fullIdentificationNumber}
        disabled
      />
      <div>
        <WizardTextInputControlledComponent
          label="EPD Version"
          tooltip="Automatically generated version number to track the EPD changes."
          name="versionNumber"
          value={metadata.versionNumber.toString().padStart(3, '0')}
          disabled
        />
        <div style={{ display: 'grid', gap: '1rem', gridTemplateColumns: 'auto auto auto 1fr' }}>
          <VersionHistoryDialog docId={docId} versions={documentVersions.data ?? []} />
          {documentVersions.data && documentVersions.data.length > 1 && (isAdmin || isLicenseeAdmin) && (
            <VersionComparerDialog
              docId={docId}
              currentVersionId={metadata.documentVersionId}
              versions={documentVersions.data}
            />
          )}
          <DocumentCommentLogButton docId={docId} hasCommentLog={!!metadata.hasCommentLog} />
        </div>
      </div>
    </>
  );
};

export default EpdMetadataRenderer;
